// extracted by mini-css-extract-plugin
export default {"label":"FormSelectCustom_label__hbHds","fieldset":"FormSelectCustom_fieldset__3CFvI","caretDown":"FormSelectCustom_caretDown__L1zAH"};